import { useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { VoiceProvider } from '@/contexts/VoiceProvider'
import { AuthBootProvider } from '@/providers/AuthBootProvider'
import { AgentBootProvider } from '@/providers/AgentBootProvider'
import { useSSEHandlers } from '@/hooks/useSSEHandlers'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { DashboardLayout } from '@/components/dashboard/DashboardLayout'
import { InboxTab } from '@/components/dashboard/InboxTab'
import { ContactsTab } from '@/components/dashboard/ContactsTab'
import { TeamTab } from '@/components/dashboard/TeamTab'
import { AnalyticsTab } from '@/components/dashboard/AnalyticsTab'
import { PowerDialerAgentTab } from '@/components/dashboard/PowerDialerAgentTab'
import { ProfilePage } from '@/components/dashboard/ProfilePage'

export function DashboardPage() {
  return (
    <VoiceProvider>
      {/* Boot prefetch : queries communes (AuthBoot) + queries softphone
          (contacts, voicemails, sms convos, etc.). Fire-and-forget en idle. */}
      <AuthBootProvider>
        <AgentBootProvider>
          <DashboardWithSSE />
        </AgentBootProvider>
      </AuthBootProvider>
    </VoiceProvider>
  )
}

function DashboardWithSSE() {
  // Branche les events SSE → invalidate queries + toasts
  useSSEHandlers()
  return (
    <DashboardLayout>
      <DashboardContent />
    </DashboardLayout>
  )
}

/** Map tab → clé i18n du libellé pour le <title> du navigateur. */
const VIEW_TITLE_KEYS: Record<string, string> = {
  phone: 'sidebar.inbox',
  sms: 'sidebar.inbox',
  conversations: 'sidebar.contacts',
  team: 'sidebar.team',
  analytics: 'sidebar.analytics',
  'power-dialer': 'manager.tabs.powerDialer',
  profile: 'manager.tabs.profile',
}

function DashboardContent() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const view = searchParams.get('view') || 'phone'

  const titleKey = VIEW_TITLE_KEYS[view]
  useDocumentTitle(titleKey ? t(titleKey) : null)

  if (view === 'conversations') return <ContactsTab />
  if (view === 'team') return <TeamTab />
  if (view === 'analytics') return <AnalyticsTab />
  if (view === 'power-dialer') return <PowerDialerAgentTab />
  if (view === 'profile') return <ProfilePage />

  // Vue inconnue, 'phone' ou ancien lien 'sms' → Boîte de réception.
  return <InboxTab />
}
